// Standalone Airhead mark loader: spin from an 8° coil, inhale coils back.

import React from 'react';
import { ASSETS } from '@airhead-games/shared/configs/assets';
import { cn } from '@/utilities/cn';
import './LogoLoader.css';

type LogoLoaderProps = {
  size?: number;
  className?: string;
};

const LogoLoader: React.FC<LogoLoaderProps> = ({ size = 48, className }) => (
  <div
    role="status"
    aria-label="Loading"
    className={cn('logo-loader relative shrink-0', className)}
    style={{ width: size, height: size }}
  >
    <div className="logo-loader__motion h-full w-full">
      <img
        src={ASSETS.logoHoleFit}
        alt=""
        aria-hidden="true"
        className="h-full w-full object-contain"
      />
    </div>
  </div>
);

export default LogoLoader;
